import ContentUpload from 'module/ContentUpload/ContentUpload';
import { unitDecisions } from 'module/AfterCopyright/AfterCopyrightContentControl';

import { useEffect } from 'react';

import { Button, Form, Input } from 'antd';
import { useAfterCopyrightUnitGeneralControlMutation, useGetArticleContentQuery } from 'services';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { fetchError } from 'slices/commonSlice';
import { openNotification, refundObjectParser } from 'utils';
import { useNavigate } from 'react-router-dom';

import AfterCommiteeDescriptions from './AfterCommiteeDescriptions';

const { TextArea } = Input;

/**
 *
 * @param {offerID} article offer id
 * @param {committee} control committee ismi ayk_control, eu_control, pub_control
 * @param {status} karar statusu unitDecisions.accept, unitDecisions.revert, unitDecisions.review, unitDecisions.reject, unitDecisions.redaction
 * @param {beforeMediaUploadNode} media alanindan once render edilecek node
 * @param {children} children olarak yollanan node media yukleme alanindan sonra render edilir
 * @returns
 */
function AfterCopyrightDecisionForm({ offerID, committee, status, beforeMediaUploadNode = null, children }) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [afterCopyrightGeneralControl] = useAfterCopyrightUnitGeneralControlMutation();

  const navigate = useNavigate();

  /**
   * Hazir seceneklerin istege eklenip eklenmemesi gerektiğini kontrol eder.
   */
  const isAddAnswersField = (Number(status) === unitDecisions.revert || Number(status) === unitDecisions.reject) && committee === 'ayk_control';

  const [form] = Form.useForm();
  const { data } = useGetArticleContentQuery({ offerID }, { skip: !offerID });

  const handleFinish = async (values) => {
    delete values.itemFile;
    delete values.idCard;

    let answers;
    if (isAddAnswersField) {
      answers = { ...values };
      refundObjectParser(answers);
    }
    if (values.redactionCommitee) {
      delete values.redactionCommitee;
    }

    const data = {
      status: Number(status),
      ...(values.to ? { to: values.to } : {}),
      ...(values.description ? { description: values.description } : {}),
      ...(values.assignments ? { assignments: values.assignments } : {}),
      ...(answers ? { answers: answers } : {}),
    };
    const { error } = await afterCopyrightGeneralControl({ data, committee, offerID: offerID });
    if (error) {
      return dispatch(
        fetchError(
          formatMessage(
            {
              id: 'article.form.fetchError',
            },
            { error: error.status }
          )
        )
      );
    }
    openNotification({
      message: formatMessage({
        id: 'appModule.actionSuccessfully',
      }),
    });
    form.resetFields();
    navigate(`/madde-teklifleri/tum-maddeler`);
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        itemFile: data.contents.find((item) => item.type === 0),
        idCard: data.contents.find((item) => item.type === 1),
      });
    }
  }, [data, form]);
  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout="vertical"
    >
      {beforeMediaUploadNode && beforeMediaUploadNode}
      <ContentUpload id={offerID} />
      {children}
      {Number(status) === unitDecisions.accept && <AfterCommiteeDescriptions commitee={committee} />}
      <Form.Item name="description">
        <TextArea
          placeholder="Notunuz varsa girebilirsiniz"
          rows={8}
          showCount
        />
      </Form.Item>
      <Button
        block
        className="gx-mt-4"
        htmlType="submit"
      >
        Gönder
      </Button>
    </Form>
  );
}
export default AfterCopyrightDecisionForm;
